import { useState } from 'react';
import logo from '../asset/icons/logo.svg';

export default function ArtImageFallback({
  src,
  alt = '',
  className = '',
  style,
  wrapperClassName = '',
  wrapperStyle,
}) {
  const [failed, setFailed] = useState(false);
  const missing = !src || (typeof src === 'string' && !src.trim());
  const showPlaceholder = missing || failed;

  const wrapperClasses = [
    'flex items-center justify-center overflow-hidden',
    showPlaceholder ? 'bg-gray-100' : '',
    wrapperClassName,
  ]
    .filter(Boolean)
    .join(' ');

  if (showPlaceholder) {
    return (
      <div className={wrapperClasses} style={wrapperStyle}>
        <div className="flex flex-col items-center justify-center px-4 py-6 text-center w-full h-full min-h-[120px]">
          <img src={logo} alt="" className="w-10 h-10 md:w-12 md:h-12 opacity-30 mb-2" aria-hidden />
          <span className="text-xs text-gray-400 tracking-wide">Image coming soon</span>
        </div>
      </div>
    );
  }

  return (
    <div className={wrapperClasses} style={wrapperStyle}>
      <img
        src={src}
        alt={alt}
        className={className}
        style={style}
        onError={() => setFailed(true)}
      />
    </div>
  );
}
